export default import.meta.ROLLUP_FILE_URL_LnIUzCutNfP53Ivi_c5Wgg